import { useEffect } from "react";
import "@/App.css";
import { SITE_MARKUP } from "@/site/markup";
import { executeGenerator } from "@/site/generator";

function App() {
  useEffect(() => {
    window.executeGenerator = executeGenerator;
    window.openSignup = () => { document.getElementById("lead-modal").style.display = "flex"; };
    window.closeSignup = () => { document.getElementById("lead-modal").style.display = "none"; };
  }, []);

  return <div data-testid="evoriq-site" dangerouslySetInnerHTML={{ __html: SITE_MARKUP }} />;
}

export default App;
